/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-button.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/component/tx-button/tx-button.component';
const styles_TxButtonComponent:any[] = [i0.styles];
export const RenderType_TxButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxButtonComponent,data:{}});
export function View_TxButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'button',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.TxButtonComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.emitClick()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),0,'i',([] as any[]),[[8,'className',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),
      (_ck,_v) => {
        var _co:i2.TxButtonComponent = _v.component;
        const currVal_0:any = i1.ɵinlineInterpolate(1,'',_co.faIconName,'');
        _ck(_v,2,0,currVal_0);
      });
}
export function View_TxButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxButtonComponent_0,
      RenderType_TxButtonComponent)),i1.ɵdid(1,114688,(null as any),0,i2.TxButtonComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxButtonComponentNgFactory:i1.ComponentFactory<i2.TxButtonComponent> = i1.ɵccf('tx-button',
    i2.TxButtonComponent,View_TxButtonComponent_Host_0,{faIconName:'faIconName'},{txOnClick:'txOnClick'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtYnV0dG9uL3R4LWJ1dHRvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9qZW5raW5zL3dvcmtzcGFjZS9wcm9kdWN0aW9uLWFyZ29zLWZyb250L2FyZ29zL3NyYy9hcHAvc2hhcmVkL2NvbXBvbmVudC90eC1idXR0b24vdHgtYnV0dG9uLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtYnV0dG9uL3R4LWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtYnV0dG9uL3R4LWJ1dHRvbi5jb21wb25lbnQudHMuVHhCdXR0b25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YnV0dG9uIChjbGljayk9XCJlbWl0Q2xpY2soKVwiPlxuICA8aSBjbGFzcz1cInt7ZmFJY29uTmFtZX19XCI+PC9pPlxuPC9idXR0b24+XG4iLCI8dHgtYnV0dG9uPjwvdHgtYnV0dG9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO1FBQUE7UUFBQTtRQUFRO1VBQUE7VUFBQTtRQUFBO1FBQVI7TUFBQSxnQ0FBOEI7TUFDNUI7VUFBQSw4REFBOEI7VUFBQSx1QkFDdkI7OztRQURKO1FBQUgsV0FBRyxTQUFIOzs7O29CQ0RGO01BQUE7a0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-button/tx-button.component.ngfactory.ts